/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { JsonPatchOperation } from '../../models/json-patch-operation';
import { Supplier } from '../../models/supplier';

export interface PatchSupplier$Params {
  bobId: string;
      body: Array<JsonPatchOperation>
}

export function patchSupplier(http: HttpClient, rootUrl: string, params: PatchSupplier$Params, context?: HttpContext): Observable<StrictHttpResponse<Supplier>> {
  const rb = new RequestBuilder(rootUrl, patchSupplier.PATH, 'patch');
  if (params) {
    rb.path('bobId', params.bobId, {});
    rb.body(params.body, 'application/json-patch+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Supplier>;
    })
  );
}

patchSupplier.PATH = '/suppliers/{bobId}';
